import { TokenRefresh } from "../../model/signup/TokenRefresh";
import type { RequestInterceptor } from "./types";

export const waitForTokenRefresh: RequestInterceptor = async (request) => {
  await TokenRefresh.waitForRefreshedAccessToken(request);
  return request;
};
